exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-pdf-preview canvas {\n  width: 100%;\n}\n\n", ""]);

// exports
